import apiClient from '@/services/api'

export default {
  async postWorkArea({ rootState, commit, dispatch }, { work_area }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/work_area/create', {
        project_id: rootState.applicationState.currentProject.id,
        work_area
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'Error while loading work areas'}`)
      }

      const updatedWorkAreas = [data.work_area, ...rootState.applicationState.workAreas]

      commit('setWorkAreas', updatedWorkAreas, { root: true })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async patchWorkArea({ rootState, commit, dispatch }, { work_area }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/work_area/update', {
        project_id: rootState.applicationState.currentProject.id,
        work_area
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'Error while loading work areas'}`)
      }

      const oldWorkAreas = [...rootState.applicationState.workAreas]

      const updatedWorkAreas = oldWorkAreas.map(item => (item.id === work_area.id ? work_area : item))

      commit('setWorkAreas', updatedWorkAreas, {
        root: true
      })

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  },

  async deleteWorkArea({ rootState, commit, dispatch }, { work_area_id }) {
    const expectedSessionId = rootState.applicationState.sessionId

    try {
      const { data } = await apiClient.post('/api/project/work_area/delete', {
        work_area_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg ?? 'Error while loading work areas'}`)
      }

      const oldWorkAreas = [...rootState.applicationState.workAreas]

      commit(
        'setWorkAreas',
        oldWorkAreas.filter(item => item.id !== work_area_id),
        {
          root: true
        }
      )

      dispatch('updateLocalStorage', { expectedSessionId }, { root: true })
    } catch (error) {
      throw error.message
    }
  }
}
